<template>
  <div>
    <el-dialog
      :visible.sync="showExportDialog"
      center
      :close-on-click-modal="true"
      @close="closeExportDialog"
      custom-class="dialog_1000 limit_height new-dialog"
      :append-to-body="true"
      title="Export Fields"
    >
      <div class="dialog_cont">
        <div class="flex list_content_box">
          <div class="left">
            <div class="input_filter">
              <i class="iconfont icon-search icon"></i>
              <el-input
                autocomplete="off"
                placeholder="Finde a filter…"
                v-model="localFilterText"
              >
              </el-input>
            </div>
            <div class="menu_box">
              <div class="frist_menu_box">
                <div
                  class="item"
                  v-for="item in filteredFilterList"
                  :key="item.moduleId"
                  @click="handleClickItem(item)"
                  :class="{ on: item.moduleId == activeItemId }"
                >
                  <OverflowTooltip :tip="item.screenName" />
                  <i class="iconfont icon-jiantouyou icon_right"></i>
                </div>
              </div>
              <div class="sec_menu_box">
                <div v-show="localCompanyOptions.length > 0">
                  <el-checkbox
                    :indeterminate="localIsIndeterminate"
                    v-model="localCheckAll"
                    @change="handleCheckAllChange"
                    >All</el-checkbox
                  >
                  <el-checkbox-group
                    v-model="localCheckedCompanyOptions"
                    @change="handleCheckedCompanyChange"
                  >
                    <el-checkbox
                      v-show="parentId == 301"
                      disabled
                      v-for="defOption in defaultSecColumns"
                      :key="defOption.moduleId"
                      :label="defOption.moduleId"
                    >
                      <OverflowTooltip :tip="defOption.screenName" />
                    </el-checkbox>
                    <el-checkbox
                      :disabled="
                        companyOption.screenName == 'Company Name' ||
                        companyOption.screenName == 'Reg. Name' ||
                        companyOption.screenName == 'Inc. Date' ||
                        companyOption.screenName == 'Co. Type' ||
                        companyOption.screenName == 'Reg. Status' ||
                        companyOption.screenName == 'State/Province' ||
                        companyOption.screenName == 'City/County' ||
                        companyOption.screenName == 'District/City'
                      "
                      v-for="companyOption in localCompanyOptions"
                      :label="companyOption.moduleId"
                      :key="companyOption.moduleId"
                    >
                      <OverflowTooltip :tip="companyOption.screenName" />
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top_select_title">
              Selected Columns ({{ localSelectedColumns.length }})
            </div>
            <ul class="sel_col_ul_box">
              <li
                class="selCol_item"
                v-for="item in localSelectedColumns"
                :key="item.moduleId"
              >
                <OverflowTooltip :tip="item.screenName" />
                <i
                  v-if="
                    ![
                      'Company Name',
                      'Reg. Name',
                      'Inc. Date',
                      'Co. Type',
                      'Reg. Status',
                      'State/Province',
                      'City/County',
                      'District/City',
                    ].includes(item.screenName)
                  "
                  class="iconfont icon-cuowu icon_cuowu"
                  @click="delChosenCol(item)"
                ></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog_footer">
        <el-button
          type="text"
          class="btn_reset_txt"
          :disabled="localSelectedColumns.length == 8"
          @click="resetDefaultView"
          >Reset Default View</el-button
        >
        <el-button class="btn_export btnbox" @click="onApplyChanges"
          >Apply Changes</el-button
        >
      </div>
    </el-dialog>

    <!-- export file name -->
    <el-dialog
      :visible.sync="localConfirmExportDialog"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @before-close="closeConExportDialog"
      custom-class="dialog_1000 new-dialog"
      :append-to-body="true"
      :title="title"
    >
      <div>
        <div class="dialog_cont">
          <div class="flie_content_box">
            <div class="fileTips">
              How many results would you like to export form this search? You
              may also fefine your search by including additional filter(s).
            </div>
            <div class="file_group">
              <label class="file_label">File Name:</label>
              <el-input
                v-model="localExportFileName"
                placeholder="Please enter a file name"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="flex_center">
        <el-button class="btn_cancel btnbox" @click="cancelExport"
          >Cancel</el-button
        >
        <el-button class="btn_export btnbox" @click.stop="backExport"
          >Back</el-button
        >

        <el-button
          class="btn_export btnbox"
          :disabled="localExportFileName == ''"
          @click="exportData"
          >Export</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getEditqueryExport, exportToolIndexInfo } from "@/api/companyApi";
export default {
  name: "exportDialog",
  props: {
    showExportDialog: {
      type: Boolean,
      default: false,
    },
    isActiveExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 定义默认列数组
    const defaultColumns = [
      {
        children: [],
        columnName: "company_name_en",
        columnNameCn: "company_name_cn",
        isShow: false,
        moduleId: 1001,
        notEditable: false,
        parentId: -1,
        screenName: "Company Name",
        sortName: "company_name",
        userEditable: true,
      },
      {
        children: [],
        columnName: "reg_name_en",
        columnNameCn: "reg_name_cn",
        isShow: false,
        moduleId: 2001,
        notEditable: false,
        parentId: -1,
        screenName: "Reg. Name",
        sortName: "reg_name_code",
        userEditable: true,
      },
      {
        children: [],
        columnName: "incorporation_date",
        columnNameCn: null,
        isShow: false,
        moduleId: 303,
        notEditable: false,
        parentId: 301,
        screenName: "Inc. Date",
        sortName: "incorporation_date",
        userEditable: false,
      },
      {
        children: [],
        columnName: "company_type_en",
        columnNameCn: "company_type_cn",
        isShow: false,
        moduleId: 305,
        notEditable: false,
        parentId: 301,
        screenName: "Co. Type",
        sortName: "company_type_code",
        userEditable: true,
      },
      {
        children: [],
        columnName: "status_en",
        columnNameCn: "status_cn",
        isShow: false,
        moduleId: 311,
        notEditable: false,
        parentId: 310,
        screenName: "Reg. Status",
        sortName: "status",
        userEditable: true,
      },
      {
        children: [],
        columnName: "province_en",
        columnNameCn: "province_cn",
        isShow: false,
        moduleId: 335,
        notEditable: false,
        parentId: 333,
        screenName: "State/Province",
        sortName: "province_en",
        userEditable: true,
      },
      {
        children: [],
        columnName: "city_en",
        columnNameCn: "city_cn",
        isShow: false,
        moduleId: 336,
        notEditable: false,
        parentId: 333,
        screenName: "City/County",
        sortName: "city_en",
        userEditable: true,
      },
      {
        children: [],
        columnName: "district_en",
        columnNameCn: "district_cn",
        isShow: false,
        moduleId: 338,
        notEditable: false,
        parentId: 333,
        screenName: "District/City",
        sortName: null,
        userEditable: true,
      },
    ];
    // 定义默认二级列数组
    const defaultSecColumns = [
      {
        children: [],
        columnName: "company_name_en",
        columnNameCn: "company_name_cn",
        isShow: false,
        moduleId: 1001,
        notEditable: false,
        parentId: 301,
        screenName: "Company Name",
        sortName: "company_name",
        userEditable: true,
      },
      {
        children: [],
        columnName: "reg_name_en",
        columnNameCn: "reg_name_cn",
        isShow: false,
        moduleId: 2001,
        notEditable: false,
        parentId: 301,
        screenName: "Reg. Name",
        sortName: "reg_name_code",
        userEditable: true,
      },
    ];
    return {
      localFilterText: "",
      localSelectedColumns: JSON.parse(JSON.stringify(defaultColumns)),
      localCheckedCompanyOptions: JSON.parse(JSON.stringify(defaultSecColumns)),
      localCompanyOptions: [],
      localIsIndeterminate: false,
      localCheckAll: false,
      localConfirmExportDialog: false,
      localExportFileName: "SearchCompanies_" + this.getCurrentDate(),
      activeItemId: null,
      title: "",
      filterList: [],
      selectedColumns: defaultColumns,
      //接口字段
      typeInfo: [],
      statusInfo: [],
      contactInfo: [],
      locationInfo: [],
      businessInfo: [],
      sizeInfo: [],
      financeInfo: [],
      parentId: -1,
      defaultSecColumns: defaultSecColumns,
    };
  },
  computed: {
    filteredFilterList() {
      if (!this.localFilterText) {
        return this.filterList;
      }
      const filterText = this.localFilterText.toLowerCase();
      return this.filterList.filter((item) =>
        item.screenName.toLowerCase().includes(filterText),
      );
    },
  },
  watch: {},
  mounted() {
    this.getExportData();
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}${month}${day}`;
    },
    //关闭一级弹窗
    closeExportDialog() {
      this.$emit("update:showExportDialog", false);
      this.resetDefaultView();
    },

    // 导出
    exportData() {
      let exportFileName = this.localExportFileName;
      if (exportFileName && !exportFileName.endsWith(".xlsx")) {
        exportFileName += ".xlsx";
      }
      let aaaIdList = [];
      this.$store.state.app.changeList.map((item) => {
        aaaIdList.push(item.aaa_id);
      });

      let params = {
        aaaIds: aaaIdList,
        typeInfo: [],
        statusInfo: [],
        contactInfo: [],
        locationInfo: [],
        businessInfo: [],
        sizeInfo: [],
        financeInfo: [],
        fileName: exportFileName,
      };

      this.localSelectedColumns.forEach((selectedItem) => {
        let parentModule = null;

        parentModule = this.filterList.find(
          (module) => module.moduleId === selectedItem.parentId,
        );

        // 如果不是直接子项，递归查找
        if (!parentModule && selectedItem.parentId !== -1) {
          const findParentModule = (modules, parentId) => {
            for (let module of modules) {
              if (module.moduleId === parentId) {
                return module;
              }
              if (module.children && module.children.length > 0) {
                let found = findParentModule(module.children, parentId);
                if (found) return found;
              }
            }
            return null;
          };

          parentModule = findParentModule(
            this.filterList,
            selectedItem.parentId,
          );
        }
        if (parentModule) {
          switch (parentModule.screenName) {
            case "Type Info":
              params.typeInfo.push(selectedItem.screenName);
              break;
            case "Status Info":
              params.statusInfo.push(selectedItem.screenName);
              break;
            case "Contact Info":
              params.contactInfo.push(selectedItem.screenName);
              break;
            case "Location Info":
              params.locationInfo.push(selectedItem.screenName);
              break;
            case "Business Info":
              params.businessInfo.push(selectedItem.screenName);
              break;
            case "Size Info":
              params.sizeInfo.push(selectedItem.screenName);
              break;
            case "Finance Info":
              params.financeInfo.push(selectedItem.screenName);
              break;
            default:
              break;
          }
        }
      });

      exportToolIndexInfo(params).then((res) => {
        if (res.status === 200) {
          this.$message({
            type: "success",
          });
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const fileName = exportFileName;
          const href = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = href;
          link.download = fileName;
          link.click();

          setTimeout(() => {
            URL.revokeObjectURL(href);
          }, 100);
        } else {
          this.$message({
            type: "error",
          });
        }
      });
      this.closeConExportDialog();
    },

    //点击一级菜单
    handleClickItem(item) {
      this.activeItemId = item.moduleId;
      this.localCheckedCompanyOptions = [];
      this.localCompanyOptions = [...item.children];
      this.parentId = item.moduleId;
      // 根据localSelectedColumns来勾选对应的localCompanyOptions
      if (this.localCompanyOptions && this.localCompanyOptions.length > 0) {
        this.localCompanyOptions.forEach((option) => {
          // 检查当前选项是否在localSelectedColumns中
          const isSelected = this.localSelectedColumns.some(
            (selected) =>
              selected.screenName === option.screenName &&
              selected.parentId === item.moduleId,
          );

          if (isSelected) {
            this.localCheckedCompanyOptions.push(option.moduleId);
          }
        });
      }

      if (this.parentId === 301) {
        this.defaultSecColumns.forEach((defOption) => {
          this.localCheckedCompanyOptions.push(defOption.moduleId);
        });
      }

      // 重新计算全选状态
      this.updateCheckAllStatus();
    },

    isOptionDisabled(option) {
      return (
        option.screenName === "Company Name" ||
        option.screenName === "Reg. Name" ||
        option.screenName === "Inc. Date" ||
        option.screenName === "Co. Type" ||
        option.screenName === "Reg. Status" ||
        option.screenName === "State/Province" ||
        option.screenName === "City/County" ||
        option.screenName === "District/City"
      );
    },

    // 更新全选状态
    updateCheckAllStatus() {
      if (this.localCompanyOptions.length === 0) {
        this.localCheckAll = false;
        this.localIsIndeterminate = false;
        return;
      }

      const totalOptions = this.localCompanyOptions.length;

      const nonDisabledOptions = this.localCompanyOptions.filter(
        (item) => !this.isOptionDisabled(item),
      );
      const totalNonDisabled = nonDisabledOptions.length;

      const disabledOptions = this.localCompanyOptions.filter((item) =>
        this.isOptionDisabled(item),
      );
      const totalDisabled = disabledOptions.length;

      const checkedNonDisabledCount = nonDisabledOptions.filter((item) =>
        this.localCheckedCompanyOptions.includes(item.moduleId),
      ).length;

      const checkedDisabledCount = disabledOptions.filter((item) =>
        this.localCheckedCompanyOptions.includes(item.moduleId),
      ).length;

      this.localCheckAll =
        (checkedNonDisabledCount === totalNonDisabled &&
          checkedDisabledCount === totalDisabled) ||
        (totalDisabled === 0 && checkedNonDisabledCount === totalNonDisabled) ||
        (totalNonDisabled === 0 && checkedDisabledCount === totalDisabled);

      // 当非禁用项或者禁用项都部分选中切禁选项加非禁选项小于总选项数时显示半选状态
      this.localIsIndeterminate =
        (checkedNonDisabledCount > 0 &&
          checkedNonDisabledCount < totalOptions &&
          checkedDisabledCount + checkedNonDisabledCount < totalOptions) ||
        (checkedDisabledCount > 0 &&
          checkedDisabledCount < totalOptions &&
          checkedDisabledCount + checkedNonDisabledCount < totalOptions);
    },

    //重置一级弹框
    resetDefaultView() {
      this.localSelectedColumns = JSON.parse(
        JSON.stringify(this.selectedColumns),
      );
      this.localCheckedCompanyOptions = [];
      this.localIsIndeterminate = false;
      this.localCheckAll = false;
      this.localFilterText = "";
      this.localCompanyOptions = [];
      this.activeItemId = null;
    },

    // 全选
    handleCheckAllChange(val) {
      const nonDisabledOptions = this.localCompanyOptions.filter(
        (item) => !this.isOptionDisabled(item),
      );

      const disabledOptionIds = this.localCompanyOptions
        .filter((item) => this.isOptionDisabled(item))
        .map((item) => item.moduleId);

      const currentlyCheckedDisabledIds =
        this.localCheckedCompanyOptions.filter((id) =>
          disabledOptionIds.includes(id),
        );

      // 获取defaultSecColumns中选项的moduleId
      const defaultSecColumnIds = this.defaultSecColumns.map(
        (item) => item.moduleId,
      );

      if (val) {
        this.localCheckedCompanyOptions = [
          ...nonDisabledOptions.map((item) => item.moduleId),
          ...currentlyCheckedDisabledIds,
          ...defaultSecColumnIds,
        ];
      } else {
        this.localCheckedCompanyOptions = [
          ...currentlyCheckedDisabledIds,
          ...defaultSecColumnIds,
        ];
      }
      this.updateSelectedColumns();
      this.updateCheckAllStatus();
    },

    //勾选二级菜单
    handleCheckedCompanyChange() {
      this.updateSelectedColumns();
      this.updateCheckAllStatus();
    },

    //更新选中的列
    updateSelectedColumns() {
      this.localSelectedColumns = this.localSelectedColumns.filter(
        (item) =>
          !this.localCompanyOptions.some(
            (option) => option.moduleId === item.moduleId,
          ),
      );
      const selectedOptions = this.localCompanyOptions.filter((item) =>
        this.localCheckedCompanyOptions.includes(item.moduleId),
      );

      this.localSelectedColumns.push(...selectedOptions);

      // 定义默认项的优先级顺序
      const defaultItems = [
        "Company Name",
        "Reg. Name",
        "Inc. Date",
        "Co. Type",
        "Reg. Status",
        "State/Province",
        "City/County",
        "District/City",
      ];

      // 排序：默认项按指定顺序排在前面，其他项保持原有顺序
      this.localSelectedColumns.sort((a, b) => {
        const aIsDefault = defaultItems.indexOf(a.screenName);
        const bIsDefault = defaultItems.indexOf(b.screenName);

        if (aIsDefault !== -1 && bIsDefault !== -1) {
          return aIsDefault - bIsDefault;
        } else if (aIsDefault !== -1) {
          return -1;
        } else if (bIsDefault !== -1) {
          return 1;
        } else {
          return 0;
        }
      });
    },

    //更新勾选状态
    updateCheckState() {
      this.updateCheckAllStatus();
    },

    //删除选中的列
    delChosenCol(item) {
      this.localSelectedColumns = this.localSelectedColumns.filter(
        (col) => col.moduleId !== item.moduleId,
      );
      this.localCheckedCompanyOptions = this.localCheckedCompanyOptions.filter(
        (id) => id !== item.moduleId,
      );
      this.updateCheckState();
    },

    // 打开确认弹窗
    onApplyChanges() {
      this.localConfirmExportDialog = true;
      this.title = `Export (${this.localSelectedColumns.length} results)`;
    },

    //关闭确认弹窗
    closeConExportDialog() {
      this.localConfirmExportDialog = false;
      this.localSelectedColumns = JSON.parse(
        JSON.stringify(this.selectedColumns),
      );
      this.localCheckedCompanyOptions = [];
      this.localIsIndeterminate = false;
      this.localCheckAll = false;
      this.localFilterText = "";
      this.localCompanyOptions = [];
      this.activeItemId = null;
      this.$emit("update:showExportDialog", false);
    },

    //取消
    cancelExport() {
      this.closeConExportDialog();
    },

    //返回
    backExport() {
      this.localConfirmExportDialog = false;
    },

    //获取数据
    getExportData() {
      getEditqueryExport().then((res) => {
        if (res.code === 200) {
          this.filterList = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog_cont {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #1a2332;
}
.input_filter {
  position: relative;
  padding: 10px;
}
.icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  pointer-events: none;
  z-index: 9;
  font-size: 20px !important;
}
.flex {
  display: flex;
  width: 100%;
  height: 100%;
}
.right,
.left {
  background: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
}
.left {
  width: 650px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
}
.right {
  width: 279px;
  display: flex;
  flex-direction: column;
}
.sel_col_ul_box {
  flex: 1;
  overflow: auto;
}
.menu_box {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.frist_menu_box {
  width: 360px;
  border-right: 1px solid #cccccc;
  overflow: auto;
}
.sec_menu_box {
  width: 289px;
  padding: 0 20px;
  overflow: auto;
}
.item {
  display: flex;
  align-items: center;
  position: relative;
  min-height: 40px;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  padding: 5px 30px 5px 20px;
  cursor: pointer;
  margin-bottom: 6px;
}
.item.on {
  background-color: #ffffff;
}
.icon_right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.top_select_title {
  padding: 20px;
  font-weight: bold;
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
}
.btn_reset_txt >>> span {
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1290c9;
}
::v-deep .btn_reset_txt.is-disabled:hover,
::v-deep .btn_reset_txt.is-disabled {
  background: #fff;
  cursor: not-allowed;
}
::v-deep .btn_reset_txt.is-disabled span {
  color: #999;
}
.fileTips {
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  font-style: normal;
  margin: 10px 0 30px;
}
.file_group {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.file_label {
  flex: none;
  margin: 14px 10px 10px 0;
  font-size: 20px;
}
.btn_cancel,
.btn_export {
  width: 210px;
  font-size: 20px;
}
.selCol_item {
  position: relative;
  padding: 5px 15px 5px 20px;
  font-size: 18px;
  line-height: 30px;
}
.icon_cuowu {
  position: absolute;
  font-size: 12px !important;
  width: 18px;
  height: 18px;
  line-height: 18px;
  right: 10px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  background: #ff6a6a;
  transform: translateY(50%);
  top: 5px;
}
.icon_suo {
  width: 16px;
  margin-left: 10px;
}
.input_filter >>> .el-input__inner {
  padding-left: 40px;
}
.file_group >>> .el-input__inner {
  width: 100%;
  font-size: 20px;
}
.sec_menu_box >>> .el-checkbox {
  margin: 10px 0;
}
::v-deep .el-dialog {
  width: 1000px !important;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 30px;
  margin-top: 10vh !important;
  display: flex;
  flex-direction: column;
}
::v-deep .limit_height {
  display: flex;
  flex-direction: column;
  height: 80vh;
  min-height: 346px;
}
::v-deep .el-dialog__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
::v-deep .el-input__inner {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  color: #1a2332;
  height: 40px;
  font-size: 18px;
}
::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner:-moz-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner::-moz-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-input__inner:-ms-input-placeholder {
  color: #999;
  opacity: 1;
}
::v-deep .el-button {
  height: 60px;
}
::v-deep .el-checkbox__label {
  vertical-align: middle;
  font-size: 18px;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}
::v-deep .btn_reset_txt + .el-button {
  margin-left: 0;
}
@media (max-width: 1920px) {
  .left {
    width: 487px;
    margin-right: 7px;
  }
  .frist_menu_box {
    width: 270px;
  }
  .sec_menu_box {
    width: 217px;
    padding: 0 15px;
  }
  .right {
    width: 209px;
  }
  .btn_cancel,
  .btn_export {
    width: 158px;
    font-size: 18px;
  }
  .btn_reset_txt >>> span {
    font-size: 18px;
  }
  .top_select_title {
    padding: 15px;
    line-height: 22px;
    font-size: 16px;
  }
  .item {
    min-height: 30px;
    font-size: 16px;
    line-height: 18px;
    padding: 5px 25px 5px 15px;
    margin-bottom: 5px;
  }
  .icon {
    left: 15px;
  }
  .fileTips {
    line-height: 22px;
    margin: 7px 0 22px;
    font-size: 18px;
  }
  .file_group {
    margin-bottom: 30px;
  }
  .file_label {
    margin: 10px 7px 7px 0;
    font-size: 18px;
  }
  .selCol_item {
    padding: 5px 11px 5px 15px;
    font-size: 16px;
    line-height: 22px;
  }
  .icon_cuowu {
    width: 14px;
    height: 14px;
    line-height: 14px;
    right: 7px;
  }
  .icon_suo {
    width: 12px;
    margin-left: 7px;
  }
  .file_group >>> .el-input__inner {
    font-size: 18px;
  }
  .sec_menu_box >>> .el-checkbox {
    margin: 7px 0;
  }
  .input_filter >>> .el-input__inner {
    padding-left: 30px;
  }
  ::v-deep .el-dialog {
    width: 750px !important;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 22px;
  }
  ::v-deep .el-button {
    height: 45px;
    min-height: 45px;
  }
  ::v-deep .el-input__inner {
    border-radius: 7px;
    font-size: 16px;
    height: 30px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 16px;
  }
}
@media (max-width: 1439px) {
  .left {
    width: 435px;
    margin-right: 6px;
  }
  .frist_menu_box {
    width: 241px;
  }
  .sec_menu_box {
    width: 194px;
    padding: 0 13px;
  }
  .right {
    width: 186px;
  }
  .btn_cancel,
  .btn_export {
    width: 140px;
    font-size: 16px;
  }
  .btn_reset_txt >>> span {
    font-size: 16px;
  }
  .top_select_title {
    padding: 13px;
    line-height: 20px;
    font-size: 14px;
  }
  .item {
    min-height: 27px;
    font-size: 14px;
    line-height: 14px;
    padding: 5px 25px 5px 15px;
    margin-bottom: 4px;
  }
  .icon {
    left: 13px;
  }
  .fileTips {
    line-height: 20px;
    margin: 6px 0 20px;
    font-size: 16px;
  }
  .file_group {
    margin-bottom: 26px;
  }
  .file_label {
    margin: 9px 6px 6px 0;
    font-size: 16px;
  }
  .selCol_item {
    padding: 5px 10px 5px 13px;
    font-size: 14px;
    line-height: 20px;
  }
  .icon_cuowu {
    width: 12px;
    height: 12px;
    line-height: 12px;
    right: 6px;
  }
  .icon_suo {
    width: 11px;
    margin-left: 6px;
  }
  .file_group >>> .el-input__inner {
    font-size: 16px;
  }
  .sec_menu_box >>> .el-checkbox {
    margin: 6px 0;
  }
  .input_filter >>> .el-input__inner {
    padding-left: 27px;
  }
  ::v-deep .el-dialog {
    width: 667px !important;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 20px;
  }
  ::v-deep .el-button {
    height: 40px;
    min-height: 40px;
  }
  ::v-deep .el-input__inner {
    border-radius: 6px;
    font-size: 14px;
    height: 27px;
  }
  ::v-deep .el-checkbox__label {
    font-size: 14px;
  }
}
</style>
